<div class="translations">
  <eiq-card [title]="'Translations'">
    <div slot="content">
      <mat-tab-group
        class="translations__tabs eiq-underlined-tabs"
        animationDuration="0ms"
        mat-stretch-tabs="false"
        mat-align-tabs="start"
        data-testid="translations-tabs"
        [selectedIndex]="activeTabIndex$()"
        (selectedIndexChange)="activeTabIndex$.set($event)"
      >
        <mat-tab>
          <ng-template mat-tab-label>
            <fa-icon [icon]="faGear"></fa-icon>
            <span class="fw__500" data-testid="translations-language-settings-tab">Language Settings</span>
          </ng-template>

          <div class="translations__language-settings">
            <empathy-language-settings (addLanguage)="onAddLanguage()"></empathy-language-settings>
          </div>
        </mat-tab>

        <mat-tab>
          <ng-template mat-tab-label>
            <fa-icon [icon]="faLanguage"></fa-icon>
            <span class="fw__500" data-testid="translations-editor-tab">Translations</span>
          </ng-template>
        </mat-tab>
      </mat-tab-group>

      <empathy-translations-editor [hidden]="activeTabIndex$() !== translationTabs.Translations" (addLanguage)="onAddLanguage()"></empathy-translations-editor>
    </div>
  </eiq-card>
</div>
